import * as React from 'react'


function Final (){

    const [timeLeft, setTimeLeft] = React.useState(5);

  React.useEffect(() => {
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  const formatsec = (time) => {
    const seconds = time % 60;
    return `${String(seconds).padStart(2, )}`;
  };

    return(
        <div className='final flex justify-center items-center space-x-4'>
        <div className='flex justify-center items-center p-6 pr-7 w-auto rounded-lg bg-orange-500'>
            <p className="text-white font-bold text-8xl px-2 pr-px">
                0
            </p>
        </div>
        <div className='flex justify-center items-center p-6 pr-7 w-auto rounded-lg bg-orange-500'>
            <p className="text-white font-bold text-8xl px-2 pr-px">
                {formatsec(timeLeft)}
            </p>
        </div>
        </div>
    )
}

export default Final